import React from 'react'
import { Helmet } from 'react-helmet'

import '../../css/Blog.css'

import WotatochGenetSchool from '../../assets/img/wotatoch-genet-school.jpg'

export default function School() {
  return (
    <div id="article">
      <Helmet>
        <title>EHDO Founding Members Visited Adwa Ber and Wotatoch Genet Schools - Enoho Fikir</title>
      </Helmet>

      <h1>EHDO Founding Members Visited Adwa Ber and Wotatoch Genet Schools</h1>
      <img src={ WotatochGenetSchool } />
      <p>The founding members of EHDO paid a visit to the school community of Adwa aber and Wotatoch Genet primary schools on February 4th 2011. This visit was made following the decision reached by the members to start a school feeding program in the two schools. On the event, EHDO members visited the classrooms, the kg compound, and the hall and met with parent representatives, teachers, admin staff of the school, the woreda officials and the mothers that prepare the food for the students and discuss various issues. Moreover, this was regarded as an introduction and also an important stepping stone towards the implementation of the school feeding program</p>
    </div>
  )
}